export const round = x => Math.round(x * 100) / 100;
//# sourceMappingURL=math.utils.js.map